import getUUID from './uuid'
import DOMPurify from 'dompurify'

function getBody(areaId: string): string[] {
	const element = document.getElementById(areaId)
	if (!element) throw new Error(`Element with id ${areaId} not found`)

	const html: string[] = []
	html.push('<div class="to-print"><div class="content">\r\n<div class="paper">')
	html.push(element.outerHTML)
	html.push('</div></div>')
	html.push('<div id="printFn" class="fn">\r\n')
	html.push('<button type="button" onclick="javascript:window.close();" class="to-button to-box-link to-form-readonly to-box-color-default to-box-mode-fill"><span class="to-icon-close to-box-color-default"><span style="font-size: 100%;"></span></span><span class="to-buttonText to-hide-keep">关闭</span></button>')
	html.push('<button type="button" class="to-button to-box-link to-form-readonly to-box-color-primary to-box-mode-fill" onclick="javascript:window.print();"><span class="to-icon-print to-box-color-default"><span style="font-size: 100%;"></span></span><span class="to-buttonText to-hide-keep">打印</span></button>')
	html.push('\r\n</div>')
	html.push('\r\n</div>')
	return html
}

function replaceBodyContent(newContent: string): string {
	const htmlString = document.documentElement.outerHTML
	const parser = new DOMParser()
	const doc = parser.parseFromString(htmlString, 'text/html')

	doc.body.innerHTML = DOMPurify.sanitize(newContent)
	return doc.documentElement.outerHTML
}

function print(areaId: string, title?: string): void {
	if (!areaId || typeof areaId !== 'string') return

	const pwin = window.open('about:blank', '_new_print_win_' + getUUID(), 'height=600,width=900,status=no,toolbar=no,menubar=no,location=no,resizable=yes')

	if (!pwin) throw new Error('Failed to open print window')

	pwin.document.write(replaceBodyContent(getBody(areaId).join('')))
	pwin.document.close()
	pwin.document.documentElement.classList.add('s_print')

	if (title && typeof title === 'string') {
		pwin.document.title = title
	}
}

export { print }
